import { lightColors } from '@/plugins/colors/base/baseColorsLight'

const backgroundTokensLight = {
  'background-primary-default': lightColors.gray.white,
  'background-primary-hover': lightColors.gray['40'],
  'background-secondary-default': lightColors.gray['40'],
  'background-secondary-hover': lightColors.gray['50'],
  'background-brand': lightColors.brand['500'],
  backdrop: lightColors.gray['900'],
  'background-light-green': lightColors.lightGreen['300']
}

export default backgroundTokensLight
